import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/users?page=1&maxData=99999999&statusId=' // (1) 사용자 목록 조회

const fetchKey = (page, pageSize) =>
	`/users?page=${page}&maxData=${pageSize}&statusId=`;

let swrData: any = getPersistData(KEY)

export function useDBList(
	statusId,
	teamId,
	responsibilityId,
	createdAt,
	assignedAt,
	updatedAt,
	customerName,
	tel,
	accessPathId,
	page = 1, pageSize = 10
) {
	const { data: token } = useToken()
	const url = fetchKey(page, pageSize);

	const { data, mutate } = useSWR<any>(
		url +
			statusId +
			'&teamId=' +
			teamId +
			'&responsibilityId=' +
			responsibilityId +
			'&createdAt=' +
			createdAt +
			'&assignedAt=' +
			assignedAt +
			'&updatedAt=' +
			updatedAt +
			'&customerName=' +
			customerName +
			'&tel=' +
			tel +
			'&accessPathId=' +
			accessPathId,
		async () => {

				const response = await API.get(
					url +
						statusId +
						'&teamId=' +
						teamId +
						'&responsibilityId=' +
						responsibilityId +
						'&createdAt=' +
						createdAt +
						'&assignedAt=' +
						assignedAt +
						'&updatedAt=' +
						updatedAt +
						'&customerName=' +
						customerName +
						'&tel=' +
						tel +
						'&accessPathId=' +
						accessPathId,
					token + '',
					{}
				)
				swrData = response.result?.result?.list

			return {
				list: response.result?.result?.list,
				total: response.result?.result?.totalCount
			};

			// catch (e) {
			// 	swrData = []
			// }
			// return swrData


		},
		{ revalidateOnFocus: true }
	)

	return {
		dbList: data?.list,
		total: data?.total,
		mutate,
	}
}
